<template>
  <div v-if="report != null" class="report-card">
    <v-card elevation="0" class="mb-0" v-if="report.dataType=='offer'">
      <v-row class="mx-0 my-0">
        <v-col cols="12" class="px-0">
          <TopBarOffer :report="report" 
                      :openDialogReport="openDialogReport" 
                      :openDialogActions="openDialogActions"/>
        </v-col>
      </v-row>
      <OfferCardSM :offer="report.offer"/>
    </v-card>
    <v-card elevation="0" class="mb-0" v-if="report.dataType=='user'">
      <v-row class="mx-0 my-0">
        <v-col cols="12" class="px-0">
          <TopBarUser :report="report"
                      :openDialogReport="openDialogReport" 
                      :openDialogActions="openDialogActionsUser"/>
        </v-col>
      </v-row>
      <UserPage :entity="report.user"/>
    </v-card>


    <v-dialog v-model="showDialogComments" transition="dialog-top-transition"
              max-width="500" :fullscreen="$vuetify.breakpoint.width < 960"
              content-class="dialog-large-bordered">
      <v-card>
        <v-toolbar elevation="0" color="transparent">
          <v-icon small color="">mdi-chevron-down</v-icon> 
          <b>Liste des signalements</b>
          <v-spacer/>
          <v-btn x-small outlined fab class=""
                @click="showDialogComments = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar> 
        <v-col cols="12">
          Hello !
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogActions" transition="dialog-top-transition"
              max-width="500" :fullscreen="$vuetify.breakpoint.width < 960"
              content-class="dialog-large-bordered">
      <v-card>
        <v-toolbar elevation="0" color="transparent">
          <v-icon small color="">mdi-chevron-down</v-icon> 
          <b>Gérer ce signalement</b>
          <v-spacer/>
          <v-btn x-small outlined fab class=""
                @click="showDialogActions = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar> 
        <v-col cols="12" v-if="objDialogActions != null && offerCreatorDialog != null">

          <v-card outlined class="mb-5">
            <div class="d-flex pt-3 ml-3 mb-2" style="font-size:20px;" v-if="offerCreatorDialog.name">
              <v-gravatar height="28" style="border-radius:50%;" class="mr-2"
                            :default-img="'retro'" :email="offerCreatorDialog.name"/>

              <b><v-icon>mdi-</v-icon> {{ offerCreatorDialog.name }}</b>
            </div>

            <v-divider/>

            <v-card-title class="pt-0">{{ objDialogActions.offer.title }}</v-card-title>
            <v-card-subtitle class="pt-0 pb-1">{{ objDialogActions.offer.text.substr(0, 100) }}</v-card-subtitle>
          </v-card>
          <v-btn block outlined color="purple" class="my-2" @click="banUser(report.offer.creator)"
                title="banir l'auteur de l'annonce">
            <v-icon>mdi-account-cancel</v-icon> Bannir l'auteur
          </v-btn>
          <v-btn block outlined color="red" class="my-2" @click="lockOffer"
                title="bloquer cette annonce">
            <v-icon>mdi-delete</v-icon> Bloquer l'annonce
          </v-btn>
          <br>
          <v-divider/>
          <br>
          <v-btn block outlined color="green" class="my-2" @click="cancelReport"
                title="conserver cette annonce et lever le signalement">
            <v-icon>mdi-cancel</v-icon> Lever le signalement
          </v-btn>
        </v-col>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showDialogActionsUser" transition="dialog-top-transition"
              max-width="500" :fullscreen="$vuetify.breakpoint.width < 960"
              content-class="dialog-large-bordered">
      <v-card>
        <v-toolbar elevation="0" color="transparent">
          <v-icon small color="">mdi-chevron-down</v-icon> 
          <b>Gérer ce signalement</b>
          <v-spacer/>
          <v-btn x-small outlined fab class=""
                @click="showDialogActionsUser = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar> 
        <v-col cols="12" v-if="offerCreatorDialogUser != null">

          <v-card outlined class="mb-5">
            <div class="d-flex pt-3 ml-3 mb-2" style="font-size:20px;" v-if="offerCreatorDialogUser.name">
              <v-gravatar height="28" style="border-radius:50%;" class="mr-2"
                            :default-img="'retro'" :email="offerCreatorDialogUser.name"/>
              <b><v-icon>mdi-</v-icon> {{ offerCreatorDialogUser.name }}</b>
            </div>

          </v-card>
          <v-btn block outlined color="purple" class="my-2" @click="banUser(offerCreatorDialogUser._id)"
                title="banir ce joueur">
            <v-icon>mdi-account-cancel</v-icon> Bannir ce joueur
          </v-btn>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>

import axios from "axios"
import OfferCardSM from '@/components/offer/OfferCardSM.vue'
import UserPage from '@/components/entity/UserPage.vue'
import TopBarOffer from '@/components/report/TopBarOffer.vue'
import TopBarUser from '@/components/report/TopBarUser.vue'
import Gravatar from 'vue-gravatar'

// import { i18n } from 'vue-lang-router';
import core from '../../plugins/core.js'
const config = require('../../config/' + process.env.NODE_ENV)

export default {
  name: 'offer-card-sm',
  components: {
    TopBarOffer, TopBarUser, OfferCardSM, UserPage, 'v-gravatar' : Gravatar
  },
  props: [ 'report' ],
  data: () => ({
    offer: null,
    showDialogReports: false,
    showDialogActions: false,
    showDialogActionsUser: false,
    showDialogComments: false,
    objDialogReport: null,
    objDialogActions: null,
    loadingCancel: false,
    loadingLock: false,
    loadingBan: false,
    offerCreatorDialog: null,
    offerCreatorDialogUser: null
  }),
  mounted: async function(){
    //this.offer = this.report.offer
  },
  methods: {
    cancelReport: function(){
      this.loadingCancel = true
      axios.post('/report/cancel', { reportId: this.report._id })
           .then((res) => {
              this.$root.$emit('loadReports')
              this.loadingCancel = false
              if(res.data.error == false){
                this.$store.dispatch('app/openSnackbar', 
                                    { show: true, color:'green', 
                                      title: "Le signalement a été annulé",
                                      text: "" })
              }else{
                this.showSnackError(res.data.errorMsg)
              }
           })
           .catch(() => {
              this.loadingCancel = false
              this.showSnackError('Erreur inconnue')
           })
    },
    lockOffer: function(){this.loadingCancel = true
      axios.post('/report/lock-offer', { reportId: this.report._id })
           .then((res) => {
              this.$root.$emit('loadReports')
              this.loadingLock = false
              if(res.data.error == false){
                this.$store.dispatch('app/openSnackbar', 
                                    { show: true, color:'green', 
                                      title: "L'annonce a été bloquée'",
                                      text: "" })
              }else{
                this.showSnackError(res.data.errorMsg)
              }
           })
           .catch(() => {
              this.loadingLock = false
              this.showSnackError('Erreur inconnue')
           })
    },
    banUser: async function(userId){
      
      this.loadingBan = true
      let resBan = await this.$store.dispatch("admin/banUser", { "userId": userId })
      this.loadingBan = false
      console.log("resBan", resBan)
      this.$root.$emit('loadReports')
      if(!resBan.error){
        this.$store.dispatch('app/openDialogMailDev', resBan.emailParams)
        this.$store.dispatch('app/openSnackbar', 
                            { show: true, color:'green', 
                              title: "Le joueur n°"+userId+" a été bloqué",
                              text: "" })
      }else{
        this.showSnackError("Une erreur est survenue")
      }
    },
    showSnackError: function(msg){
      this.$store.dispatch('app/openSnackbar', 
                            { show: true, color:'red', 
                              title: "Une erreur est survenue",
                              text: msg })
    },
    openDialogActions: async function(report){
      this.offerCreatorDialog = null
      this.showDialogActions = true 
      this.objDialogActions = report
      let res = await axios.post('/admin/query-entities', {
                        entityType: "user",
                        query: { _id: report.offer.creator }
                    })

      if(res.data.error == false)
        this.offerCreatorDialog = res.data.entities[0]

    },
    openDialogActionsUser: async function(report){
      console.log("openDialogActionsUser", report.user)
      this.offerCreatorDialogUser = null
      this.showDialogActionsUser = true 
      this.objDialogActions = report
      let res = await axios.post('/admin/query-entities', {
                        entityType: "user",
                        query: { _id: report.user._id }
                    })

      if(res.data.error == false)
        this.offerCreatorDialogUser = res.data.entities[0]

    },
    openDialogComments: function(){
      this.showDialogComments = true 
    },
    nl2br: function(str, is_xhtml){
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'
      let newStr = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
      let maxLength = 150
      let p = newStr.length > maxLength ? '...' : ''
      newStr = newStr.substr(0, maxLength) + p
      return newStr
    },
    monyToEuro(amount){ return amount * config.monyToEuro },
    baseUrl(){ return core.baseUrl() },
    openDialogReport() { 
      this.$root.$emit("openDialogReport", this.report)
    }
  },
  computed: {
  },
}
</script>
